import { Speech2Text } from './speech2text.ts';

export {
  Speech2Text
}